import React, { FC, Fragment } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { FloatButton } from 'antd';

// Импортируем необходимые изображения (предполагаем, что они есть в проекте)
import Phone1 from 'static/images/landingMarketPlace/phone1.webp';
import Phone2 from 'static/images/landingMarketPlace/phone2.webp';
import Phone3 from 'static/images/landingMarketPlace/phone3.webp';
import Phone4 from 'static/images/landingMarketPlace/phone4.webp';
import Phone5 from 'static/images/landingMarketPlace/phone5.webp';
import GradientTelegram from 'static/images/landingMarketPlace/gradientTelegramm.webp';
import GradientPink from 'static/images/landingMarketPlace/gradientPink.webp';

import { DemoEmail } from '../components/DemoEmail';

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    background: linear-gradient(180deg, #F8F2FF 0%, #FFFFFF 100%);
    font-family: 'Space Grotesk', sans-serif;
  }
`;

export const HeroSection: FC = () => {
    return (
        <Fragment>
            <GlobalStyle />
            <StyledContainer>
                <HeroSectionContent>
                    <HeroContent>
                        <Title>
                            Создай приложение в{' '}
                            <HighlightPurple>Telegram</HighlightPurple> на базе
                            товаров из маркетплейсов с{' '}
                            <HighlightPink>ИИ-продавцом!</HighlightPink>
                        </Title>
                        <Subtitle>
                            Оставьте почту и получите ранний доступ к сервису.
                        </Subtitle>
                        <DemoEmail />
                    </HeroContent>
                    <PhonesShowcase>
                        <PhoneGrid>
                            {[Phone1, Phone2, Phone3, Phone4, Phone5].map(
                                (phone, index) => (
                                    <PhoneImage
                                        key={index}
                                        src={phone}
                                        alt={`Phone demo ${index + 1}`}
                                    />
                                )
                            )}
                        </PhoneGrid>
                    </PhonesShowcase>
                </HeroSectionContent>
            </StyledContainer>
        </Fragment>
    );
};

const StyledContainer = styled.div`
    width: 100%;
    max-width: 1160px;
    margin: 0 auto;
    padding: 0 20px;

    @media (max-width: 992px) {
        padding: 0;
    }
`;

const HeroSectionContent = styled.section`
    padding: 80px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
`;

const HeroContent = styled.div`
    margin: 0 auto;
`;

const Title = styled.h1`
    font-size: 44px;
    font-weight: 700;
    line-height: 1.2;
    color: #3b3b3b;
    margin: 0 0 48px;
    font-family: 'Unbounded';

    @media (max-width: 992px) {
        font-size: 30px;
        text-align: center;
        margin-bottom: 32px;
        br {
            display: none;
        }
    }
`;

const HighlightPurple = styled.span`
    background: url(${GradientTelegram});
    background-size: cover;
    background-position: center;
    color: #3b3b3b;
    font-weight: 700;
    font-family: 'Unbounded';
    padding: 0 8px;
    border-radius: 4px;
    white-space: nowrap;
`;

const HighlightPink = styled.span`
    background: url(${GradientPink});
    background-size: cover;
    background-position: center;
    color: #3b3b3b;
    font-weight: 700;
    font-family: 'Unbounded';
    padding: 0 8px;
    border-radius: 4px;
    white-space: nowrap;
`;

const Subtitle = styled.p`
    font-size: 20px;
    line-height: 1.5;
    color: #666666;
    margin-bottom: 32px;
`;

const PhonesShowcase = styled.div`
    margin-top: 60px;
    width: 100%;
    overflow: hidden;
`;

const PhoneGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 20px;
`;

const PhoneImage = styled.img`
    width: 100%;
    height: auto;
`;

export default HeroSection;
